import React from 'react';
import Snackbar from '@mui/material/Snackbar';

export default class SnackbarShow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  

  render() {
    const {props, state} = this;
    return (
      <div>
        <Snackbar
          open={state.open}
          message={props.message}
          autoHideDuration={4000}
        />
      </div>
    );
  }
}
